import styled from 'styled-components';

const HtmlResetWrapper = styled.div`
  width: auto;
`;

export { HtmlResetWrapper };
